import React, { useContext, useEffect, useState } from "react";
import { BASE_URL, UserContext } from "../contexts/UserContext";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import ButtonLoader from "../components/ButtonLoader";
import "./editPost.css";

const EditPost = () => {
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [thumbnail, setThumbnail] = useState('');
  const { error, setError, setMessage } = useContext(UserContext);
  const navigate = useNavigate()
  const { postId } = useParams()

 useEffect(() => {
  const getPostDetails = async () => {
    try {
      setLoading(true);

      const { data } = await axios.get(
        `${BASE_URL}/posts/post/details/${postId}`,
        { withCredentials: true }
      );

      // 👇 Backend ke according check karo
      const post = data.post || data.posts;

      setTitle(post?.title || "");
      setCategory(post?.category || "");
      setDescription(post?.description || "");

      setError(null);

    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (postId) {
    getPostDetails();
  }
}, [postId]); // 👈 IMPORTANT

  const handleUpdatePost = async (e) => {
  e.preventDefault();
    try {
      setUpdateLoading(true);
      const myForm = new FormData();
      myForm.append('title', title);
      myForm.append('category', category);
      myForm.append('description', description);
      myForm.append('photo', thumbnail);
      console.log(myForm);
      const { data } = await axios.put(`${BASE_URL}/posts/update/post/${postId}`,
        myForm,
        {
          headers: {
            "Content-Type": "multipart/form-data"       
            },
          withCredentials: true,
        }
      );

      setMessage(data?.message);
      setError(null);
      navigate('/')

    } catch (error) {
      setError(error.response.data.message);

    } finally {
      setUpdateLoading(false);
    }
  }






  //   toolbar: [
  //     [{ header: [1, 2,3, 4, 5, 6, false] }],
  //     ["bold", "italic", "underline", "strike", "blockquote"],
  //     [
  //       { list: "ordered" },
  //       { list: "bullet" },
  //       { indent: "-1" },
  //       { indent: "+1" },
  //     ],
  //     ["link", "image"],
  //     ["clean"],
  //   ],
  // };
  // const formats = [
  //   "header",
  //   "bold",
  //   "italic",
  //   "underline",
  //   "strike",
  //   "blockquote",
  //   "list",
  //   "bullet",
  //   "indent",
  //   "link",
  //   "image",
  // ];

  const POST_CATEGORTIES = [
    "Uncategoize",
    "Agriclture",
    "Business",
    "Education",
    "Ebtertainment",
    "Art",
    "Investment",
    "Weather",
  ];

  return (
  loading ? (
    <Loader />
  ) : (
    <section className="edit-post">
      <div className="edit-post__container">
        <h2 className="edit-post__title">Edit Post</h2>

        {error && (
          <p className="form__error-message">
            {error}
          </p>
        )}

        <form className="edit-post__form" onSubmit={handleUpdatePost}>
          
          <div className="form-group">
            <label>Post Title</label>
            <input
              type="text"
              placeholder="Enter post title"
              autoFocus
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Category</label>
            <select
              name="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              {POST_CATEGORTIES.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              placeholder="Write your post description..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Thumbnail Image</label>
            <input
              type="file"
              onChange={(e) => setThumbnail(e.target.files[0])}
              accept="image/png, image/jpg, image/jpeg"
            />
          </div>

          <button
            type="submit"
            className="btn primary"
            disabled={updateLoading}
          >
            {updateLoading ? <ButtonLoader /> : "Update Post"}
          </button>

        </form>
      </div>
    </section>
  )
);
};

export default EditPost;
